import { ExportToCsv } from "export-to-csv";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  triggerDashboardAudit,
  triggerFetchEarnings,
  triggerFetchEarningsCSV,
  triggerFetchTimeStamp,
} from "../../../redux/actions";
import PropTypes from "prop-types";
import { earningsDispValue, getPartnerRoleID } from "../../../utils/common";
import { earningsCsvFilter } from "../../../utils/common/csvMappings/earningsCsv";
import EarningsTabsView from "../../../views/myEarningsView/components/EarningTabsView";
import {
  fetchShowAlertEarnings,
  hideAlertEarnings,
} from "../../../redux/actions/earningsAction";

function EarningsTabs(props) {
  const dispatch = useDispatch();

  const { earningsObj, earningsCSVObj } = useSelector(
    (state) => state.earningReducer
  );
  const {
    getAllAPI,
    filterValue,
    headerSelectedDateFrom,
    headerSelectedDateTo,
    // partnerRoleType,
    // filterList
  } = useSelector((state) => state.homeReducer);
  const getURL = {
    Activation: {
      url: props.url,
      csvUrl: props.csvEndPointUrl,
      type: "Activation",
    },
    Recharge: {
      url: props.url,
      csvUrl: props.csvEndPointUrl,
      csvDispValue: "margin",
      type: "Recharge",
    },
    Device: {
      url: props.url,
      csvUrl: props.csvEndPointUrl,
      csvDispValue: "schemepayout",
      type: "Device",
    },
  };

  const getSection = (url) => {
    let earningsSection = {
      "/dist-earning-jiophone": "jiophone",
      "/dist-earning-devices": "device",
      default: props && props.earningsModel && props.earningsModel.sectionName,
    };
    return earningsSection[url] || earningsSection["default"];
  };

  let obj = {
    headers: {
      "Content-Type": "application/json",
    },
    params: {
      dispValue: 10000,
      fromDate: headerSelectedDateFrom,
      id: filterValue.selectedRole.split(" - ")[2] ?? filterValue.orgId,
      isRedisActive: "YES",
      jprTypeName: "",
      moduleName: props.moduleName, //props && props && props.earningsModel && props.earningsModel.sectionName,
      partnerRoleType: filterValue.selectedPartnerRoleName,
      section: getSection(props.url), //jiophone & device for device section
      type: getURL[
        props && props && props.earningsModel && props.earningsModel.sectionName
      ].type,
      toDate: headerSelectedDateTo,
      url: getURL[
        props && props && props.earningsModel && props.earningsModel.sectionName
      ].url,
      csvUrl:
        getURL[
          props &&
            props &&
            props.earningsModel &&
            props.earningsModel.sectionName
        ].csvUrl,
    },
    tab: getSection(props.url),
  };

  let timeStampObj = {
    headers: {
      "Content-Type": "application/json",
    },
    params: {
      moduleName: props.moduleName,
      partnerRole: getPartnerRoleID(filterValue.selectedPartnerRoleName),
    },
  };

  useEffect(() => {
    function fetchData() {
      return dispatch(triggerFetchEarnings(obj));
    }
    if (
      earningsObj &&
      earningsObj.data &&
      earningsObj.data[props.url] === undefined
    ) {
      fetchData();
    }

    const fetchTimeStamp = () => {
      timeStampObj.params = {
        ...timeStampObj.params,
        subModule: props.earningsModel.sectionName,
      };
      // console.log("props.moduleName", props.moduleName);

      return dispatch(
        triggerFetchTimeStamp(
          timeStampObj,
          `${props.moduleName} ${props.earningsModel.sectionName}`
        )
      );
    };

    if (
      getAllAPI &&
      getAllAPI.data &&
      getAllAPI.data.content &&
      getAllAPI.data.content[0]
    ) {
      return fetchTimeStamp();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterValue, headerSelectedDateFrom, headerSelectedDateTo, getAllAPI]);

  const sendAudit = () => {
    const obj = {
      headers: {
        url: "/add-dashboard-audit",
      },
      params: {
        action: "download",
        dashboard: props.moduleName,
        empId: filterValue?.orgId?.length
          ? filterValue?.orgId
          : filterValue?.agentId,
        empRole: filterValue.partnerName,
        remarks: "Dashboard Audit request",
        userType: filterValue?.site,
        viewName: props.earningsModel.sectionName,
      },
    };
    triggerDashboardAudit(obj);
  };

  function csv(rowName) {
    sendAudit();

    let options = {
      fieldSeparator: ",",
      quoteStrings: '"',
      decimalSeparator: ".",
      showLabels: true,
      showTitle: false,
      filename: "MyEarnings",
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true,
      // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
    };
    let csvExporter = new ExportToCsv(options);
    let dispValue = earningsDispValue(rowName);
    function fetchCsv() {
      let obj = {
        headers: {
          "Content-Type": "application/json",
        },
        params: {
          dispValue: dispValue,
          fromDate: headerSelectedDateFrom,
          id: filterValue.selectedRole.split(" - ")[2] ?? filterValue.orgId,
          isRedisActive: "YES",
          jprTypeName: "",
          moduleName: props.moduleName,
          partnerRoleType: filterValue.selectedPartnerRoleName,
          type: getURL[
            props &&
              props &&
              props.earningsModel &&
              props.earningsModel.sectionName
          ].type,
          section: getSection(props.url),
          toDate: headerSelectedDateTo,
          csvUrl:
            getURL[
              props &&
                props &&
                props.earningsModel &&
                props.earningsModel.sectionName
            ].csvUrl,
        },
        tab: rowName,
      };
      return dispatch(
        triggerFetchEarningsCSV(obj, (response, params) => {
          if (response?.content?.length) {
            const data = earningsCsvFilter(
              getSection(props.url),
              rowName,
              response.content
            );
            // console.log(data)
            csvExporter.generateCsv(data);
          } else {
            dispatch(fetchShowAlertEarnings(props.component));
            setTimeout(() => {
              dispatch(hideAlertEarnings());
            }, 5000);
          }
        })
      );
    }
    if (dispValue) {
      fetchCsv();
    }
  }

  return (
    <EarningsTabsView
      getSection={getSection}
      triggerFetchEarnings={triggerFetchEarnings}
      triggerFetchEarningsCSV={triggerFetchEarningsCSV}
      filterValue={filterValue}
      headerSelectedDateFrom={headerSelectedDateFrom}
      headerSelectedDateTo={headerSelectedDateTo}
      earningsObj={earningsObj}
      earningsCSVObj={earningsCSVObj}
      data={props.data}
      sectionName={props.moduleName}
      csv={csv}
      isCsvActive={props.isCsvActive}
      key={props.index}
      earningsCsvFilter={earningsCsvFilter}
      earningsDispValue={earningsDispValue}
      getURL={getURL}
      url={props.url}
    />
  );
}
EarningsTabs.propTypes = {
  url: PropTypes.string,
  csvEndPointUrl: PropTypes.string,
  isCsvActive: PropTypes.string,
  filterValue: PropTypes.object,
  headerSelectedDateFrom: PropTypes.string,
  headerSelectedDateTo: PropTypes.string,
};

export default EarningsTabs;
